export const assetTypeConstants = {
    TEMP: 'temp',
    IMAGE: 'image',
    CSS : "css"
};
